import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import {AccountService} from "./account.service";
import {VoucherTemplate} from "../models/voucherTemplate";
import {Product} from "../models/product";
import {Items} from "../models/items";

@Injectable({ providedIn: 'root' })
export class VoucherTemplateService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll() {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllBy(value: string) {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates?filters[allFields]=` + value, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllForPos() {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates?sortCol=posOrder&sortDir=asc`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getOpenDayVouchers() {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates?filters[forOpenDay]=1`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getMultiSportVouchers() {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates?filters[multiSport]=1`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getMedicoverVouchers() {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates?filters[medicover]=1`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getProfitVouchers() {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates?filters[profit]=1`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getPzuSportVouchers() {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates?filters[pzuSport]=1`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getTopSelling() {
        return this.http.get<VoucherTemplate[]>(`${environment.apiEndpoint}/v1/voucher-templates?sortCol=soldQuantity&sortDir=DESC&limit=10`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<VoucherTemplate>(`${environment.apiEndpoint}/v1/voucher-templates/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/voucher-templates/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    updateOrder(params) {
        return this.http.put(`${environment.apiEndpoint}/v1/voucher-templates/pos/sorting`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/voucher-templates`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/voucher-templates/` + id, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
